import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PackageService {
  readonly name = '@apexdesigner/beyond-basics';
  readonly version = '2.2.12';
  readonly description = '';
  readonly displayName = 'Beyond Basics Online';
}
